module.exports = __webpack_public_path__ + "img/btn1-370x300.18537bc8.jpg";